import { Tab, TabProps, Typography, useTheme } from '@mui/material';

// Extend TabProps so MUI's Tabs can inject selected, onChange, textColor, etc.
// via cloneElement and have them reach the underlying Tab.
interface NavTabProps extends Omit<TabProps, 'label'> {
  label: string;
  activeValue: number;
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export function NavTab({ value, label, activeValue, ...tabProps }: NavTabProps) {
  const theme = useTheme();

  return (
    <Tab
      value={value}
      label={
        <Typography
          variant='nav2'
          textTransform='none'
          sx={{
            fontWeight:
              activeValue === value
                ? theme.typography.fontWeightBold
                : theme.typography.fontWeightRegular,
          }}
          color={theme.palette.taiga.main}
        >
          {label}
        </Typography>
      }
      {...tabProps}
      {...a11yProps(value as number)}
    />
  );
}
